// extracted by mini-css-extract-plugin
export default {"subtitle":"Rooms_subtitle__2yAcC","title":"Rooms_title__yFIs7","container":"Rooms_container__oERkN","columns":"Rooms_columns__1oLZq"};